export const SET_LOGIN_DETAILS = "SET_LOGIN_DETAILS";
export const SET_OPTION_DATA = "SET_OPTION_DATA";
export const RESET_APP = "RESET_APP";
